import { render, staticRenderFns } from "./StudentEvaluationList.vue?vue&type=template&id=0ee5e7ee&"
import script from "./StudentEvaluationList.vue?vue&type=script&lang=js&"
export * from "./StudentEvaluationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports